import { z } from 'zod';
export const FEED_FORMAT_OPTIONS = ['threaded', 'linear'];
export const feedFormatSchema = z.enum(FEED_FORMAT_OPTIONS);
export const DEFAULT_FEED_FORMAT = 'threaded';
export const isFeedFormat = (value) => value === 'threaded' || value === 'linear';
export const parseFeedFormat = (value) => isFeedFormat(value) ? value : DEFAULT_FEED_FORMAT;
/** Profile default, then community default, then threaded. */
export const resolveFeedFormat = (profileFormat, communityFormat) => {
    if (isFeedFormat(profileFormat))
        return profileFormat;
    if (isFeedFormat(communityFormat))
        return communityFormat;
    return DEFAULT_FEED_FORMAT;
};
